import moment from "moment";

export const getTimeDifference = async (timeToCompare) => {
    if (timeToCompare) {
        const a = moment().unix()
        const b = timeToCompare

        let aa = moment.unix(a); // converted value
        let bb = moment.unix(b); // converted value

        let days = aa.diff(bb, "days");
        aa.add(days, "years");

        let hours = aa.diff(bb, "hour");
        aa.add(hours, "hours");

        let seconds = aa.diff(bb, "seconds");
        var minutes = aa.diff(bb, "minutes");

        // console.log(days + " days " + hours + " hours " + seconds + " seconds");

        return { inDays: days, inHours: hours, inMinutes: minutes, inSeconds: seconds }
    }

    return null
}


